import React, { PropsWithChildren } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { InfiniteScrollConfigType } from "../../../utils/infiniteScrollUtil";

type InfiniteScrollWrapperProps<T> = {
  scrollConfig?: InfiniteScrollConfigType<T>;
  enableInfiniteScroll: boolean;
};
const InfiniteScrollWrapper = <T extends {}>({
  children,
  scrollConfig,
  enableInfiniteScroll,
}: PropsWithChildren<InfiniteScrollWrapperProps<T>>) =>
  enableInfiniteScroll ? (
    <InfiniteScroll
      scrollableTarget={scrollConfig ? scrollConfig.scrollableTarget : ""}
      dataLength={scrollConfig ? scrollConfig.tableData.length : 0}
      next={scrollConfig ? scrollConfig.next : () => {}}
      hasMore={scrollConfig ? scrollConfig.hasMore : false}
      loader={null}
    >
      {children}
    </InfiniteScroll>
  ) : (
    <>{children}</>
  );

export default InfiniteScrollWrapper;
